import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface UnshareProjectUserMutationInput {
  projectId: number;
  userId: number;
}

/**
 * Mutation hook for removing a user-scoped share from a project (Owner/Admin only).
 * Calls DELETE /projects/:id/share/user/:userId.
 * Invalidates the project detail so share arrays refresh.
 */
export function useUnshareProjectUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ projectId, userId }: UnshareProjectUserMutationInput) => {
      await apiClient.delete(`/projects/${projectId}/share/user/${userId}`);
    },
    onSuccess: (_data, { projectId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projects.byId(projectId) });
    },
  });
}
